// eslint-disable-next-line no-restricted-imports
export class ColonistI18n {
    t(key, options) {
        const invalidTranslation = 'Invalid Translation';
        try {
            const translation = this.instance.t(key, options);
            return typeof translation == 'string' ? translation : invalidTranslation;
        } catch (e) {
            return invalidTranslation;
        }
    }
    tArray(key, options) {
        const invalidTranslation = [
            'Invalid Translation'
        ];
        try {
            const allOptions = ColonistI18n.addReturnObjectOption(options);
            const translation = this.instance.t(key, allOptions);
            if (Array.isArray(translation)) return translation;
            return invalidTranslation;
        } catch (e) {
            return invalidTranslation;
        }
    }
    static addReturnObjectOption(options) {
        return options == undefined ? {
            returnObjects: true
        } : {
            ...options,
            returnObjects: true
        };
    }
    constructor(i18next){
        this.instance = i18next;
    }
}
(function(I18n) {
    I18n.defaultLanguage = 'en';
    I18n.languages = [
        'en',
        'af',
        'ar',
        'ca',
        'cs',
        'da',
        'de',
        'el',
        'es',
        'fi',
        'fr',
        'he',
        'hi',
        'hu',
        'it',
        'ja',
        'ko',
        'nl',
        'no',
        'pl',
        'pt-BR',
        'pt-PT',
        'ro',
        'ru',
        'sr',
        'sv',
        'th',
        'tr',
        'uk',
        'vi',
        'zh-CN',
        'zh-TW'
    ];
    I18n.languageEnglishNames = {
        /* eslint-disable @typescript-eslint/naming-convention */ en: 'English',
        af: 'Afrikaans',
        ar: 'Arabic',
        ca: 'Catalan',
        cs: 'Czech',
        da: 'Danish',
        de: 'German',
        el: 'Greek',
        es: 'Spanish',
        fi: 'Finnish',
        fr: 'French',
        he: 'Hebrew',
        hi: 'Hindi',
        hu: 'Hungarian',
        it: 'Italian',
        ja: 'Japanese',
        ko: 'Korean',
        nl: 'Dutch',
        no: 'Norwegian',
        pl: 'Polish',
        'pt-BR': 'Brazilian Portuguese',
        'pt-PT': 'European Portuguese',
        ro: 'Romanian',
        ru: 'Russian',
        sr: 'Serbian',
        sv: 'Swedish',
        th: 'Thai',
        tr: 'Turkish',
        uk: 'Ukrainian',
        vi: 'Vietnamese',
        'zh-CN': 'Chinese (China Mainland)',
        'zh-TW': 'Chinese (Taiwan)'
    };
})(I18n || (I18n = {}));
export var I18n;
